// src/components/StaffManagement.js
import React, { useState } from 'react';

const StaffManagement = ({ staff, onNavigate }) => {
  const [selectedShift, setSelectedShift] = useState('all');
  const [selectedDepartment, setSelectedDepartment] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [showAttendanceModal, setShowAttendanceModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);

  // Complete Staff Database
const [staffList, setStaffList] = useState([
  {
    id: 1,
    employeeId: 'HK1001',
    name: 'Rajesh Kumar',
    position: 'Senior Housekeeper',
    department: 'Housekeeping',
    shift: 'morning',
    shiftTime: '6:00 AM - 2:00 PM',
    contact: '+91 98765 43210',
    email: 'rajesh.kumar@hotel.com',
    joinDate: '2020-03-15',
    rating: 4.8,
    avatar: '👨',
    status: 'active',
    currentCheckIn: '2024-01-15 06:15 AM',
    assignedFloors: [1, 2],
    currentRoom: 101,
    tasksCompleted: 145,
    attendance: 98,
    emergencyContact: '+91 98765 43211',
    address: '123 Staff Colony, Hotel premises, Mumbai'
  },
  {
    id: 2,
    employeeId: 'HK1002',
    name: 'Priya Sharma',
    position: 'Housekeeper',
    department: 'Housekeeping',
    shift: 'morning',
    shiftTime: '6:00 AM - 2:00 PM',
    contact: '+91 98765 43212',
    email: 'priya.sharma@hotel.com',
    joinDate: '2021-06-20',
    rating: 4.6,
    avatar: '👩',
    status: 'active',
    currentCheckIn: '2024-01-15 06:00 AM',
    assignedFloors: [2, 3],
    currentRoom: 205,
    tasksCompleted: 98,
    attendance: 95,
    emergencyContact: '+91 98765 43213',
    address: '456 Staff Quarters, Delhi'
  },
  {
    id: 3,
    employeeId: 'HK1003',
    name: 'Amit Patel',
    position: 'Housekeeper',
    department: 'Housekeeping',
    shift: 'afternoon',
    shiftTime: '2:00 PM - 10:00 PM',
    contact: '+91 98765 43214',
    email: 'amit.patel@hotel.com',
    joinDate: '2021-09-10',
    rating: 4.5,
    avatar: '👨',
    status: 'active',
    currentCheckIn: '2024-01-15 01:55 PM',
    assignedFloors: [3, 4],
    currentRoom: 304,
    tasksCompleted: 87,
    attendance: 92,
    emergencyContact: '+91 98765 43215',
    address: '789 Staff Hostel, Bangalore'
  },
  {
    id: 4,
    employeeId: 'HK1004',
    name: 'Sneha Reddy',
    position: 'Supervisor',
    department: 'Management',
    shift: 'morning',
    shiftTime: '6:00 AM - 2:00 PM',
    contact: '+91 98765 43216',
    email: 'sneha.reddy@hotel.com',
    joinDate: '2019-01-10',
    rating: 4.9,
    avatar: '👩',
    status: 'active',
    currentCheckIn: '2024-01-15 05:45 AM',
    assignedFloors: [1, 2, 3, 4, 5],
    currentRoom: null,
    tasksCompleted: 320,
    attendance: 99,
    emergencyContact: '+91 98765 43217',
    address: '12 Staff Villa, Hyderabad'
  },
  {
    id: 5,
    employeeId: 'HK1005',
    name: 'Vikram Singh',
    position: 'Night Housekeeper',
    department: 'Housekeeping',
    shift: 'night',
    shiftTime: '10:00 PM - 6:00 AM',
    contact: '+91 98765 43218',
    email: 'vikram.singh@hotel.com',
    joinDate: '2022-02-28',
    rating: 4.4,
    avatar: '👨',
    status: 'active',
    currentCheckIn: '2024-01-14 09:55 PM',
    assignedFloors: [5, 6],
    currentRoom: 502,
    tasksCompleted: 56,
    attendance: 88,
    emergencyContact: '+91 98765 43219',
    address: '34 Night Shift Quarters, Chennai'
  },
  {
    id: 6,
    employeeId: 'HK1006',
    name: 'Anjali Desai',
    position: 'Housekeeper',
    department: 'Housekeeping',
    shift: 'morning',
    shiftTime: '6:00 AM - 2:00 PM',
    contact: '+91 98765 43220',
    email: 'anjali.desai@hotel.com',
    joinDate: '2022-05-15',
    rating: 4.7,
    avatar: '👩',
    status: 'active',
    currentCheckIn: '2024-01-15 06:10 AM',
    assignedFloors: [4, 5],
    currentRoom: 405,
    tasksCompleted: 67,
    attendance: 94,
    emergencyContact: '+91 98765 43221',
    address: '56 Staff Apartments, Pune'
  },
  {
    id: 7,
    employeeId: 'HK1007',
    name: 'Rahul Verma',
    position: 'Housekeeper',
    department: 'Housekeeping',
    shift: 'afternoon',
    shiftTime: '2:00 PM - 10:00 PM',
    contact: '+91 98765 43222',
    email: 'rahul.verma@hotel.com',
    joinDate: '2022-08-20',
    rating: 4.3,
    avatar: '👨',
    status: 'on-leave',
    currentCheckIn: null,
    assignedFloors: [6, 7],
    currentRoom: null,
    tasksCompleted: 34,
    attendance: 85,
    emergencyContact: '+91 98765 43223',
    address: '78 Staff Colony, Ahmedabad'
  },
  {
    id: 8,
    employeeId: 'HK1008',
    name: 'Meera Nair',
    position: 'Senior Housekeeper',
    department: 'Housekeeping',
    shift: 'morning',
    shiftTime: '6:00 AM - 2:00 PM',
    contact: '+91 98765 43224',
    email: 'meera.nair@hotel.com',
    joinDate: '2020-11-05',
    rating: 4.8,
    avatar: '👩',
    status: 'active',
    currentCheckIn: '2024-01-15 06:05 AM',
    assignedFloors: [7, 8],
    currentRoom: 708,
    tasksCompleted: 132,
    attendance: 97,
    emergencyContact: '+91 98765 43225',
    address: '90 Staff Homes, Kochi'
  },
  {
    id: 9,
    employeeId: 'HK1009',
    name: 'Arun Joshi',
    position: 'Housekeeper',
    department: 'Housekeeping',
    shift: 'night',
    shiftTime: '10:00 PM - 6:00 AM',
    contact: '+91 98765 43226',
    email: 'arun.joshi@hotel.com',
    joinDate: '2023-01-12',
    rating: 4.2,
    avatar: '👨',
    status: 'active',
    currentCheckIn: '2024-01-14 10:00 PM',
    assignedFloors: [8, 9],
    currentRoom: 805,
    tasksCompleted: 23,
    attendance: 90,
    emergencyContact: '+91 98765 43227',
    address: '101 Night Staff Quarters, Jaipur'
  },
  {
    id: 10,
    employeeId: 'HK1010',
    name: 'Kavita Rao',
    position: 'Floor Supervisor',
    department: 'Management',
    shift: 'afternoon',
    shiftTime: '2:00 PM - 10:00 PM',
    contact: '+91 98765 43228',
    email: 'kavita.rao@hotel.com',
    joinDate: '2021-04-18',
    rating: 4.7,
    avatar: '👩',
    status: 'active',
    currentCheckIn: '2024-01-15 02:00 PM',
    assignedFloors: [9, 10],
    currentRoom: 902,
    tasksCompleted: 78,
    attendance: 93,
    emergencyContact: '+91 98765 43229',
    address: '123 Executive Staff, Lucknow'
  }
]);

  // Attendance records
  const [attendanceRecords, setAttendanceRecords] = useState([
    { id: 1, staffId: 1, date: '2024-01-15', checkIn: '06:15 AM', checkOut: null, status: 'checked-in', floor: 1, room: 101 },
    { id: 2, staffId: 2, date: '2024-01-15', checkIn: '06:00 AM', checkOut: null, status: 'checked-in', floor: 2, room: 205 },
    { id: 3, staffId: 3, date: '2024-01-15', checkIn: '01:55 PM', checkOut: null, status: 'checked-in', floor: 3, room: 304 },
    { id: 4, staffId: 4, date: '2024-01-15', checkIn: '05:45 AM', checkOut: null, status: 'checked-in', floor: null, room: null },
    { id: 5, staffId: 5, date: '2024-01-14', checkIn: '09:55 PM', checkOut: '06:00 AM', status: 'checked-out', floor: 5, room: 502 },
  ]);

  const shifts = [
    { id: 'morning', label: 'Morning Shift', time: '6:00 AM - 2:00 PM', icon: '🌅', color: 'bg-orange-100 text-orange-700' },
    { id: 'afternoon', label: 'Afternoon Shift', time: '2:00 PM - 10:00 PM', icon: '☀️', color: 'bg-yellow-100 text-yellow-700' },
    { id: 'night', label: 'Night Shift', time: '10:00 PM - 6:00 AM', icon: '🌙', color: 'bg-blue-100 text-blue-700' }
  ];

  const departments = [
    { id: 'all', label: 'All Departments' },
    { id: 'Housekeeping', label: 'Housekeeping' },
    { id: 'Management', label: 'Management' }
  ];

  const floors = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  const getShiftDetails = (shiftId) => {
    return shifts.find(s => s.id === shiftId);
  };

  const handleCheckIn = (staffMember, floor, room) => {
    const updatedStaff = staffList.map(s =>
      s.id === staffMember.id
        ? { ...s, status: 'active', currentCheckIn: new Date().toLocaleString(), currentRoom: room }
        : s
    );
    setStaffList(updatedStaff);

    const newRecord = {
      id: attendanceRecords.length + 1,
      staffId: staffMember.id,
      date: new Date().toISOString().split('T')[0],
      checkIn: new Date().toLocaleTimeString(),
      checkOut: null,
      status: 'checked-in',
      floor: floor,
      room: room
    };
    setAttendanceRecords([...attendanceRecords, newRecord]);
    setShowAttendanceModal(false);
  };

  const handleCheckOut = (staffMember) => {
    const updatedStaff = staffList.map(s =>
      s.id === staffMember.id
        ? { ...s, status: 'active', currentCheckIn: null, currentRoom: null }
        : s
    );
    setStaffList(updatedStaff);

    const updatedRecords = attendanceRecords.map(record =>
      record.staffId === staffMember.id && record.status === 'checked-in'
        ? { ...record, checkOut: new Date().toLocaleTimeString(), status: 'checked-out' }
        : record
    );
    setAttendanceRecords(updatedRecords);
  };

  const filteredStaff = staffList.filter(staffMember => {
    const matchesShift = selectedShift === 'all' || staffMember.shift === selectedShift;
    const matchesDepartment = selectedDepartment === 'all' || staffMember.department === selectedDepartment;
    const matchesSearch = staffMember.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         staffMember.employeeId.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         staffMember.position.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesShift && matchesDepartment && matchesSearch;
  });

  const stats = {
    totalStaff: staffList.length,
    activeStaff: staffList.filter(s => s.status === 'active').length,
    onLeave: staffList.filter(s => s.status === 'on-leave').length,
    checkedIn: attendanceRecords.filter(r => r.status === 'checked-in').length,
    morningShift: staffList.filter(s => s.shift === 'morning').length,
    afternoonShift: staffList.filter(s => s.shift === 'afternoon').length,
    nightShift: staffList.filter(s => s.shift === 'night').length,
    avgRating: (staffList.reduce((sum, s) => sum + s.rating, 0) / staffList.length).toFixed(1)
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Staff Management</h1>
          <p className="text-sm text-gray-500 mt-1">Manage housekeeping staff, attendance, and floor assignments</p>
        </div>
        <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition flex items-center gap-2">
          <span>➕</span> Add New Staff
        </button>
      </div>

      {/* Statistics Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Total Staff</p>
              <p className="text-2xl font-bold text-gray-900">{stats.totalStaff}</p>
              <p className="text-xs text-green-600 mt-1">Active: {stats.activeStaff}</p>
            </div>
            <div className="bg-blue-100 rounded-full p-3">
              <span className="text-2xl">👥</span>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Currently Checked In</p>
              <p className="text-2xl font-bold text-green-600">{stats.checkedIn}</p>
              <p className="text-xs text-gray-500 mt-1">On duty now</p>
            </div>
            <div className="bg-green-100 rounded-full p-3">
              <span className="text-2xl">✅</span>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Average Rating</p>
              <p className="text-2xl font-bold text-yellow-600">{stats.avgRating} ⭐</p>
              <p className="text-xs text-gray-500 mt-1">Performance score</p>
            </div>
            <div className="bg-yellow-100 rounded-full p-3">
              <span className="text-2xl">⭐</span>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Today's Attendance</p>
              <p className="text-2xl font-bold text-purple-600">94%</p>
              <p className="text-xs text-gray-500 mt-1">{stats.checkedIn}/{stats.activeStaff} present</p>
            </div>
            <div className="bg-purple-100 rounded-full p-3">
              <span className="text-2xl">📊</span>
            </div>
          </div>
        </div>
      </div>

      {/* Shift Distribution */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {shifts.map(shift => (
          <div key={shift.id} className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
            <div className="flex items-center gap-3">
              <div className={`w-12 h-12 rounded-full flex items-center justify-center text-2xl ${shift.color}`}>
                {shift.icon}
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-gray-900">{shift.label}</h3>
                <p className="text-xs text-gray-500">{shift.time}</p>
              </div>
              <div className="text-right">
                <p className="text-2xl font-bold text-gray-900">
                  {stats[`${shift.id}Shift`]}
                </p>
                <p className="text-xs text-gray-500">Staff</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Filters */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Search</label>
            <input
              type="text"
              placeholder="Name, ID or Position..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Shift</label>
            <select
              value={selectedShift}
              onChange={(e) => setSelectedShift(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
            >
              <option value="all">All Shifts</option>
              <option value="morning">Morning Shift</option>
              <option value="afternoon">Afternoon Shift</option>
              <option value="night">Night Shift</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Department</label>
            <select
              value={selectedDepartment}
              onChange={(e) => setSelectedDepartment(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
            >
              {departments.map(dept => (
                <option key={dept.id} value={dept.id}>{dept.label}</option>
              ))}
            </select>
          </div>
          <div className="flex items-end">
            <button
              onClick={() => {
                setSearchTerm('');
                setSelectedShift('all');
                setSelectedDepartment('all');
              }}
              className="w-full px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition"
            >
              Clear Filters
            </button>
          </div>
        </div>
      </div>

      {/* Staff Table */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">Employee</th>
                <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">ID</th>
                <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">Position</th>
                <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">Shift</th>
                <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">Assigned Floors</th>
                <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">Current Room</th>
                <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">Check In/Out</th>
                <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {filteredStaff.map(staffMember => {
                const shiftDetails = getShiftDetails(staffMember.shift);
                const isCheckedIn = attendanceRecords.some(r => r.staffId === staffMember.id && r.status === 'checked-in');
                const currentRecord = attendanceRecords.find(r => r.staffId === staffMember.id && r.status === 'checked-in');
                
                return (
                  <tr key={staffMember.id} className="hover:bg-gray-50 transition">
                    <td className="px-5 py-3">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-xl">
                          {staffMember.avatar}
                        </div>
                        <div>
                          <div className="font-semibold text-gray-900">{staffMember.name}</div>
                          <div className="text-xs text-gray-500">{staffMember.email}</div>
                        </div>
                      </div>
                    </td>
                    <td className="px-5 py-3">
                      <code className="text-sm font-mono text-gray-600">{staffMember.employeeId}</code>
                    </td>
                    <td className="px-5 py-3">
                      <div className="font-medium text-gray-900">{staffMember.position}</div>
                      <div className="text-xs text-gray-500">{staffMember.department}</div>
                    </td>
                    <td className="px-5 py-3">
                      <span className={`inline-flex items-center gap-1 px-2 py-1 text-xs rounded-full ${shiftDetails?.color}`}>
                        {shiftDetails?.icon} {shiftDetails?.label}
                      </span>
                      <div className="text-xs text-gray-400 mt-1">{shiftDetails?.time}</div>
                    </td>
                    <td className="px-5 py-3">
                      <div className="flex flex-wrap gap-1">
                        {staffMember.assignedFloors.map(floor => (
                          <span key={floor} className="inline-flex px-2 py-0.5 bg-gray-100 text-gray-600 text-xs rounded">
                            Floor {floor}
                          </span>
                        ))}
                      </div>
                    </td>
                    <td className="px-5 py-3">
                      {staffMember.currentRoom ? (
                        <span className="inline-flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded-full">
                          🏠 Room {staffMember.currentRoom}
                        </span>
                      ) : (
                        <span className="text-sm text-gray-400">—</span>
                      )}
                    </td>
                    <td className="px-5 py-3">
                      <span className={`inline-flex items-center gap-1 px-2 py-1 text-xs rounded-full ${
                        staffMember.status === 'active' 
                          ? 'bg-green-100 text-green-700'
                          : staffMember.status === 'on-leave'
                          ? 'bg-yellow-100 text-yellow-700'
                          : 'bg-gray-100 text-gray-700'
                      }`}>
                        {staffMember.status === 'active' ? '🟢 Active' : staffMember.status === 'on-leave' ? '🟡 On Leave' : '⚪ Inactive'}
                      </span>
                      {isCheckedIn && (
                        <div className="text-xs text-green-600 mt-1">✓ Checked In</div>
                      )}
                    </td>
                    <td className="px-5 py-3">
                      {isCheckedIn ? (
                        <button
                          onClick={() => handleCheckOut(staffMember)}
                          className="px-3 py-1 bg-red-600 text-white text-sm rounded-lg hover:bg-red-700 transition"
                        >
                          Check Out
                        </button>
                      ) : (
                        <button
                          onClick={() => {
                            setSelectedStaff(staffMember);
                            setShowAttendanceModal(true);
                          }}
                          className="px-3 py-1 bg-green-600 text-white text-sm rounded-lg hover:bg-green-700 transition"
                        >
                          Check In
                        </button>
                      )}
                    </td>
                    <td className="px-5 py-3">
                      <button
                        onClick={() => setSelectedStaff(staffMember)}
                        className="text-blue-600 hover:text-blue-800 text-sm font-medium"
                      >
                        View Details →
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Staff Details Modal */}
      {selectedStaff && !showAttendanceModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={() => setSelectedStaff(null)}>
          <div className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-white border-b border-gray-200 p-5 flex justify-between items-center">
              <h3 className="text-xl font-bold text-gray-900">Staff Details</h3>
              <button onClick={() => setSelectedStaff(null)} className="text-gray-400 hover:text-gray-600">✕</button>
            </div>
            
            <div className="p-5 space-y-6">
              {/* Profile Header */}
              <div className="flex items-center gap-4">
                <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center text-4xl">
                  {selectedStaff.avatar}
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-900">{selectedStaff.name}</h2>
                  <p className="text-gray-500">{selectedStaff.position}</p>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-sm text-yellow-600">⭐ {selectedStaff.rating}</span>
                    <span className="text-sm text-gray-400">|</span>
                    <span className="text-sm text-gray-500">ID: {selectedStaff.employeeId}</span>
                  </div>
                </div>
              </div>

              {/* Contact Information */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="border rounded-lg p-3">
                  <p className="text-xs text-gray-500">Contact Number</p>
                  <p className="font-medium">{selectedStaff.contact}</p>
                </div>
                <div className="border rounded-lg p-3">
                  <p className="text-xs text-gray-500">Email Address</p>
                  <p className="font-medium">{selectedStaff.email}</p>
                </div>
                <div className="border rounded-lg p-3">
                  <p className="text-xs text-gray-500">Emergency Contact</p>
                  <p className="font-medium">{selectedStaff.emergencyContact}</p>
                </div>
                <div className="border rounded-lg p-3">
                  <p className="text-xs text-gray-500">Address</p>
                  <p className="font-medium text-sm">{selectedStaff.address}</p>
                </div>
              </div>

              {/* Work Information */}
              <div className="border rounded-lg p-4">
                <h4 className="font-semibold text-gray-900 mb-3">Work Information</h4>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <p className="text-xs text-gray-500">Join Date</p>
                    <p className="text-sm">{selectedStaff.joinDate}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Shift Timing</p>
                    <p className="text-sm">{getShiftDetails(selectedStaff.shift)?.time}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Tasks Completed</p>
                    <p className="text-sm font-semibold text-blue-600">{selectedStaff.tasksCompleted}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Attendance Rate</p>
                    <p className="text-sm font-semibold text-green-600">{selectedStaff.attendance}%</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Assigned Floors</p>
                    <div className="flex flex-wrap gap-1 mt-1">
                      {selectedStaff.assignedFloors.map(floor => (
                        <span key={floor} className="px-2 py-0.5 bg-gray-100 text-xs rounded">Floor {floor}</span>
                      ))}
                    </div>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Current Status</p>
                    <span className={`inline-flex mt-1 px-2 py-0.5 text-xs rounded-full ${
                      selectedStaff.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'
                    }`}>
                      {selectedStaff.status === 'active' ? 'Active' : 'On Leave'}
                    </span>
                  </div>
                </div>
              </div>

              {/* Attendance History */}
              <div className="border rounded-lg p-4">
                <h4 className="font-semibold text-gray-900 mb-3">Recent Attendance</h4>
                <div className="space-y-2">
                  {attendanceRecords.filter(r => r.staffId === selectedStaff.id).slice(0, 5).map(record => (
                    <div key={record.id} className="flex justify-between items-center text-sm border-b pb-2">
                      <span className="text-gray-600">{record.date}</span>
                      <span>Check In: {record.checkIn || '—'}</span>
                      <span>Check Out: {record.checkOut || '—'}</span>
                      <span className={`px-2 py-0.5 text-xs rounded ${
                        record.status === 'checked-in' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'
                      }`}>
                        {record.status}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Check In Modal */}
      {showAttendanceModal && selectedStaff && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={() => setShowAttendanceModal(false)}>
          <div className="bg-white rounded-xl max-w-md w-full p-6" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-900">Check In - {selectedStaff.name}</h3>
              <button onClick={() => setShowAttendanceModal(false)} className="text-gray-400 hover:text-gray-600">✕</button>
            </div>
            <div className="space-y-4">
              <div className="p-3 bg-blue-50 rounded-lg">
                <p className="text-sm text-gray-600">Shift: {getShiftDetails(selectedStaff.shift)?.label}</p>
                <p className="text-sm text-gray-600 mt-1">Time: {getShiftDetails(selectedStaff.shift)?.time}</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Select Floor</label>
                <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none">
                  {selectedStaff.assignedFloors.map(floor => (
                    <option key={floor} value={floor}>Floor {floor}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Room Number</label>
                <input
                  type="text"
                  placeholder="Enter room number"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                />
              </div>
              <button
                onClick={() => handleCheckIn(selectedStaff, 1, 101)}
                className="w-full py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
              >
                Confirm Check In
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StaffManagement;